//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ROSIER_info",
  data() {
    return {
    };
  },
  components: {
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  }
};



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/ER/ROSIER_info.vue